import Deployement from "./shared/deployement";
import Header from "./shared/header";
import Product from "./shared/product";
import TextContainer from "./shared/textContainer";
import WhitePaper from "./shared/whitepaper";
import Contact from "./shared/contact";
import Footer from "./shared/footer";
import Strategy from "./shared/strategy";

import HeroBackground from "./shared/hero_background";
import DesktopLayout from "./shared/desktop_layout";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";
import MobileHero from "./shared/mobile_hero";
import DesktopHero from "./shared/desktop_hero";

function DigitalExperience() {
  const carouselData = [
    {
      title: "Boost Customer Engagement",
      description:
        "Set up chatbot for bank in Philippines with 90% increase in NLP accuracy while engaging in over 15,000 conversations per month.",
    },
    {
      title: "Drive Digital Adoption",
      description:
        "We received the platform on time and within budget but also enabled us to think outside the box in terms of the capabilities and services that could transform our business. In short, they are the definition of an innovative tech partner.",
    },
  ];

  const productList = [
    {
      title: "personalized offerings",
      description:
        "Improve engagement on the app using personalized offers and insights",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.9953 1.8667C11.7243 1.8667 8.26198 5.32903 8.26198 9.60003C8.26198 13.1264 10.6222 16.1014 13.8491 17.0317C11.3038 17.3426 9.12052 18.2434 7.47561 19.8645C5.38086 21.929 4.32031 25.0023 4.32031 29.0129C4.32031 29.5725 4.774 30.0262 5.33365 30.0262C5.89329 30.0262 6.34698 29.5725 6.34698 29.0129C6.34698 25.3435 7.31302 22.8702 8.89819 21.308C10.4864 19.7429 12.8573 18.9329 16.0002 18.9329C19.143 18.9329 21.5141 19.7429 23.1023 21.308C24.6875 22.8703 25.6536 25.3435 25.6535 29.0128C25.6535 29.5725 26.1072 30.0262 26.6668 30.0262C27.2265 30.0262 27.6802 29.5725 27.6802 29.0129C27.6803 25.0023 26.6197 21.929 24.5248 19.8645C22.8784 18.242 20.6927 17.341 18.1444 17.0308C21.3698 16.0997 23.7286 13.1253 23.7286 9.60003C23.7286 5.32903 20.2663 1.8667 15.9953 1.8667ZM10.2886 9.60003C10.2886 6.44833 12.8436 3.89337 15.9953 3.89337C19.147 3.89337 21.702 6.44833 21.702 9.60003C21.702 12.7517 19.147 15.3067 15.9953 15.3067C12.8436 15.3067 10.2886 12.7517 10.2886 9.60003Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "rapid iteration",
      description: "Drive conversions through rapid iterations of campaigns. ",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.5558 0.086089C19.0079 0.279549 19.2692 0.757031 19.1884 1.24211L17.262 12.8001H26.6695C27.0736 12.8001 27.4429 13.0284 27.6236 13.3897C27.8043 13.7511 27.7653 14.1835 27.5229 14.5067L14.7229 31.5734C14.4278 31.9668 13.902 32.1075 13.4499 31.9141C12.9978 31.7206 12.7365 31.2431 12.8174 30.7581L14.7437 19.2001H5.3362C4.93218 19.2001 4.56283 18.9718 4.38215 18.6104C4.20146 18.2491 4.24046 17.8166 4.48287 17.4934L17.2829 0.426748C17.5779 0.0333345 18.1037 -0.107371 18.5558 0.086089ZM7.46954 17.0667H16.0029C16.3164 17.0667 16.6141 17.2047 16.8168 17.4439C17.0194 17.6832 17.1066 17.9995 17.055 18.3088L15.6408 26.7939L24.5362 14.9334H16.0029C15.6893 14.9334 15.3917 14.7955 15.189 14.5562C14.9863 14.317 14.8992 14.0007 14.9507 13.6914L16.3649 5.20626L7.46954 17.0667Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "multi channel",
      description:
        "Engage with customers on multiple channels and via chatbots for inbound and outbound use-cases",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.97295 2.13343L5.86558 2.13337C5.37822 2.1329 4.95809 2.1325 4.58592 2.22185C3.41584 2.50276 2.50227 3.41633 2.22136 4.58641C2.13201 4.95858 2.13241 5.3787 2.13288 5.86606L2.13295 5.97343V11.0934L2.13288 11.2008C2.13241 11.6882 2.13201 12.1083 2.22136 12.4805C2.50227 13.6505 3.41584 14.5641 4.58592 14.845C4.95809 14.9344 5.37822 14.934 5.86558 14.9335L5.97295 14.9334H11.0929L11.2003 14.9335C11.6877 14.934 12.1078 14.9344 12.48 14.845C13.65 14.5641 14.5636 13.6505 14.8445 12.4805C14.9339 12.1083 14.9335 11.6882 14.933 11.2008L14.9329 11.0934V5.97343L14.933 5.86607C14.9335 5.3787 14.9339 4.95858 14.8445 4.58641C14.5636 3.41633 13.65 2.50276 12.48 2.22185C12.1078 2.1325 11.6877 2.1329 11.2003 2.13337L11.0929 2.13343H5.97295ZM5.08394 4.29624C5.17575 4.2742 5.31634 4.26677 5.97295 4.26677H11.0929C11.7496 4.26677 11.8901 4.2742 11.982 4.29624C12.372 4.38988 12.6765 4.6944 12.7701 5.08443C12.7922 5.17624 12.7996 5.31683 12.7996 5.97343V11.0934C12.7996 11.75 12.7922 11.8906 12.7701 11.9824C12.6765 12.3725 12.372 12.677 11.982 12.7706C11.8901 12.7927 11.7496 12.8001 11.0929 12.8001H5.97295C5.31634 12.8001 5.17575 12.7927 5.08394 12.7706C4.69391 12.677 4.38939 12.3725 4.29575 11.9824C4.27371 11.8906 4.26628 11.75 4.26628 11.0934V5.97343C4.26628 5.31683 4.27371 5.17624 4.29575 5.08443C4.38939 4.6944 4.69391 4.38988 5.08394 4.29624ZM20.9063 2.13343L20.7989 2.13337C20.3116 2.1329 19.8914 2.1325 19.5193 2.22185C18.3492 2.50276 17.4356 3.41633 17.1547 4.58641C17.0653 4.95858 17.0657 5.3787 17.0662 5.86606L17.0663 5.97343V11.0934L17.0662 11.2008C17.0657 11.6882 17.0653 12.1083 17.1547 12.4805C17.4356 13.6505 18.3492 14.5641 19.5193 14.845C19.8914 14.9344 20.3116 14.934 20.7989 14.9335L20.9063 14.9334H26.0263L26.1336 14.9335C26.621 14.934 27.0411 14.9344 27.4133 14.845C28.5834 14.5641 29.497 13.6505 29.7779 12.4805C29.8672 12.1083 29.8668 11.6882 29.8664 11.2008L29.8663 11.0934V5.97343L29.8664 5.86607C29.8668 5.3787 29.8672 4.95858 29.7779 4.58641C29.497 3.41633 28.5834 2.50276 27.4133 2.22185C27.0411 2.1325 26.621 2.1329 26.1337 2.13337L26.0263 2.13343H20.9063ZM20.0173 4.29624C20.1091 4.2742 20.2497 4.26677 20.9063 4.26677H26.0263C26.6829 4.26677 26.8235 4.2742 26.9153 4.29624C27.3053 4.38988 27.6098 4.6944 27.7035 5.08443C27.7255 5.17624 27.7329 5.31683 27.7329 5.97343V11.0934C27.7329 11.75 27.7255 11.8906 27.7035 11.9824C27.6098 12.3725 27.3053 12.677 26.9153 12.7706C26.8235 12.7927 26.6829 12.8001 26.0263 12.8001H20.9063C20.2497 12.8001 20.1091 12.7927 20.0173 12.7706C19.6272 12.677 19.3227 12.3725 19.2291 11.9824C19.207 11.8906 19.1996 11.75 19.1996 11.0934V5.97343C19.1996 5.31683 19.207 5.17624 19.2291 5.08443C19.3227 4.6944 19.6272 4.38988 20.0173 4.29624ZM5.86558 17.0667L5.97295 17.0668H11.0929L11.2003 17.0667C11.6877 17.0662 12.1078 17.0658 12.48 17.1552C13.65 17.4361 14.5636 18.3497 14.8445 19.5197C14.9339 19.8919 14.9335 20.312 14.933 20.7994L14.9329 20.9068V26.0268L14.933 26.1341C14.9335 26.6215 14.9339 27.0416 14.8445 27.4138C14.5636 28.5839 13.65 29.4974 12.48 29.7784C12.1078 29.8677 11.6877 29.8673 11.2003 29.8668L11.0929 29.8668H5.97295L5.86558 29.8668C5.37822 29.8673 4.95809 29.8677 4.58592 29.7784C3.41584 29.4974 2.50227 28.5839 2.22136 27.4138C2.13201 27.0416 2.13241 26.6215 2.13288 26.1341L2.13295 26.0268V20.9068L2.13288 20.7994C2.13241 20.312 2.13201 19.8919 2.22136 19.5197C2.50227 18.3497 3.41584 17.4361 4.58592 17.1552C4.95809 17.0658 5.37822 17.0662 5.86558 17.0667ZM5.97295 19.2001C5.31634 19.2001 5.17575 19.2075 5.08394 19.2296C4.69391 19.3232 4.38939 19.6277 4.29575 20.0178C4.27371 20.1096 4.26628 20.2502 4.26628 20.9068V26.0268C4.26628 26.6834 4.27371 26.824 4.29575 26.9158C4.38939 27.3058 4.69391 27.6103 5.08394 27.704C5.17575 27.726 5.31634 27.7334 5.97295 27.7334H11.0929C11.7496 27.7334 11.8901 27.726 11.982 27.704C12.372 27.6103 12.6765 27.3058 12.7701 26.9158C12.7922 26.824 12.7996 26.6834 12.7996 26.0268V20.9068C12.7996 20.2502 12.7922 20.1096 12.7701 20.0178C12.6765 19.6277 12.372 19.3232 11.982 19.2296C11.8901 19.2075 11.7496 19.2001 11.0929 19.2001H5.97295ZM20.9063 17.0668L20.7989 17.0667C20.3116 17.0662 19.8914 17.0658 19.5193 17.1552C18.3492 17.4361 17.4356 18.3497 17.1547 19.5197C17.0653 19.8919 17.0657 20.312 17.0662 20.7994L17.0663 20.9068V26.0268L17.0662 26.1341C17.0657 26.6215 17.0653 27.0416 17.1547 27.4138C17.4356 28.5839 18.3492 29.4974 19.5193 29.7784C19.8914 29.8677 20.3116 29.8673 20.7989 29.8668L20.9063 29.8668H26.0263L26.1336 29.8668C26.621 29.8673 27.0411 29.8677 27.4133 29.7784C28.5834 29.4974 29.497 28.5839 29.7779 27.4138C29.8672 27.0416 29.8668 26.6215 29.8664 26.1341L29.8663 26.0268V20.9068L29.8664 20.7994C29.8668 20.312 29.8672 19.8919 29.7779 19.5197C29.497 18.3497 28.5834 17.4361 27.4133 17.1552C27.0411 17.0658 26.621 17.0662 26.1337 17.0667L26.0263 17.0668H20.9063ZM20.0173 19.2296C20.1091 19.2075 20.2497 19.2001 20.9063 19.2001H26.0263C26.6829 19.2001 26.8235 19.2075 26.9153 19.2296C27.3053 19.3232 27.6098 19.6277 27.7035 20.0178C27.7255 20.1096 27.7329 20.2502 27.7329 20.9068V26.0268C27.7329 26.6834 27.7255 26.824 27.7035 26.9158C27.6098 27.3058 27.3053 27.6103 26.9153 27.704C26.8235 27.726 26.6829 27.7334 26.0263 27.7334H20.9063C20.2497 27.7334 20.1091 27.726 20.0173 27.704C19.6272 27.6103 19.3227 27.3058 19.2291 26.9158C19.207 26.824 19.1996 26.6834 19.1996 26.0268V20.9068C19.1996 20.2502 19.207 20.1096 19.2291 20.0178C19.3227 19.6277 19.6272 19.3232 20.0173 19.2296Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
  ];

  const strategyDataMobile = [
    {
      img: "images/customer/platform.webp",
      title: "Platform Agnostic",
      description:
        "Help define an over-arching customer-engagement strategy, covering omni-channel interactions, campaigns and personalization.",
    },
    {
      img: "images/customer/bird.webp",
      title: "A Bird’s Eye View",
      description:
        "Set up data ingestion pipelines from multiple sources and maintain 360-degree view of customer",
    },
    {
      img: "images/customer/insights.webp",
      title: "Extract Insights with Analytics",
      description:
        "Enrich with analytics to derive additional customer features, extract insights and decide on next best actions and offers.",
    },
  ];

  const strategyDataWeb = [
    {
      img: "images/customer/strategy/img1.png",
      title: "Strategy",
      description:
        "Help define an over-arching customer-engagement strategy, covering omni-channel interactions, campaigns and personalization.",
    },
    {
      img: "images/customer/strategy/img2.png",
      title: "Customer 360 degree view",
      description:
        "Set up data ingestion pipelines from multiple sources and maintain 360-degree view of customer",
    },
    {
      img: "images/customer/strategy/img3.png",
      title: "Enrich with Analytics",
      description:
        "Enrich with analytics to derive additional customer features, extract insights and decide on next best actions and offers.",
    },
    {
      img: "images/customer/strategy/img4.png",
      title: "Omni Channel Experience",
      description:
        "Engage with customers on the apps, via chatbots, on different channels like WhatsApp, Viber, SMS, email, and many more.",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <DesktopHero
        heroImage={"images/customer/hero.webp"}
        heading="Deploy a MarTech+ Stack to deliver personalized experiences"
        title={"MARTECH+"}
        backgroundColor="red-pink"
        name="MarTech+"
      />

      <MobileHero
        heading={"Deploy a MarTech+ Stack to deliver personalized experiences"}
        title={"MARTECH+"}
        backgroundColor="red-pink"
      />

      <Layout>
        <div className=" sm:hidden w-[88%] mx-auto">
          <div>&nbsp;</div>
          <img
            src="/images/customer/digital_experience_hero_mob.webp"
            alt="frame1"
            className=" mt-[40px]"
          />
        </div>
      </Layout>

      <Layout>
        <TextContainer
          text1="OneByZero can help define a holistic customer experience strategy, covering omni-channel interactions, campaigns and personalization, and also help achieve the vision!"
          text2="Setup data ingestion pipelines, create a 360-degree view of all customers and engage with customers in a personalized way across channels."
        />
      </Layout>

      <Layout backgroundColor="black">
        <Strategy
          title={"Why work with OneByZero on MarTech+?"}
          description={
            "The OneByZero team has deep experience in different aspects of customer experience, including customer value management, next-best-action, personalized recommendations, campaigns, omni-channel messaging, chatbots, etc."
          }
          img="images/customer/strategy.webp"
          dataMobile={strategyDataMobile}
          dataWeb={strategyDataWeb}
        />
      </Layout>

      <Layout>
        <Product
          title={"Take your products to the next level with LLMs"}
          description={
            "OnebyZero’s mission is “Empowering businesses across the APJ region with cutting-edge Data and AI solutions by delivering unparalleled value, innovation, and domain expertise."
          }
          list={productList}
        />
      </Layout>

      {/* <Layout backgroundColor="black">
        <Deployement
          title={"Accelerated Deployment"}
          description={
            "OnebyZero’ uses several accelerators in the space of XXXX to speed up the deployment of use-cases."
          }
          text1={
            "Hyper-personalized content generation for marketing and customer engagement use-cases"
          }
          text2={"Generation of data stories, especially video data stories"}
          text3={
            "Collection, indexing and serving of data for enterprise search systems"
          }
        />
      </Layout> */}

      <Layout>
        <WhitePaper
          heading={"Boost Engagement with better Customer Experiences"}
          subHeading={"Welcome to the future of business."}
          title={"Start Connecting with your Customers"}
          description={
            "Discover how you can improve customer satisfaction rates and lower churn by increasing the number of channels you interact with customers"
          }
          carouselData={carouselData}
        />
      </Layout>

      <Layout backgroundColor="black">
        <Contact
          title={
            "See how MarTech+ can revolutionize your business, and improve customer engagement and employee productivity"
          }
          type="service"
        />
        <Footer />
      </Layout>
    </div>
  );
}

export default DigitalExperience;
